/*
  Keeps the category carousel's dots in step with the track, and lets a dot scroll to its
  card. Progressive enhancement only: the track is a scroll-snap row that works without
  this file, so nothing here is required for the section to function.
*/
(function () {
  function init(root) {
    var track = root.querySelector('[data-ns-mg-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ns-mg-dot]'));
    if (!track || !dots.length) return;

    function activate(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }

    // Which card is nearest the left edge of the track?
    var frame;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        var items = track.children;
        if (!items.length) return;
        var edge = track.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < items.length; i++) {
          var dist = Math.abs(items[i].offsetLeft - track.offsetLeft - edge);
          if (dist < bestDist) { bestDist = dist; best = i; }
        }
        activate(best);
      });
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var item = track.children[i];
        if (!item) return;
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        activate(i);
      });
    });
  }

  function boot() {
    document.querySelectorAll('.ns-media-grid--carousel').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.ns-media-grid--carousel').forEach(init);
  });
})();
